export default __webpack_public_path__ + "static/media/create_meeting_card_image.75b54cb9.png";